import BaseLayout from '../base/BaseLayout';
import Navbar from '../components/navbar/Navbar';
import Actions from '../components/actions/Actions';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar } from '../../redux/settings/actions';
import { IAppState } from '../../interfaces/app-state';
import MyMenu from '../components/my-menu/MyMenu';
import WebLogo from '../components/logo/WebLogo';
import { useLanguage } from '../../components/LanguageContext';
import { useTranslation } from 'react-i18next';
import { AppState } from '../../redux/store';
import useFacebookPixel from '../../hooks/facebookPixelHook';
import { useGetProfileByRoleApi } from '../../hooks/Client/UseClient';

type Props = {
    children: any;
};

const ClientLayout = ({ children }: Props) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const settings = useSelector((state: IAppState) => state.settings);
    const state = useSelector((state: AppState) => state)
    const role = state.client.Token ? 'client' : state.consultant.Token ? "consultant" : state.admin.Token ? "admin" : ""
    const pixelId = process.env.REACT_APP_PIXEL_ID;
    const trackPixelEvent = useFacebookPixel(pixelId);
    const [MyProfile] = useGetProfileByRoleApi(role, 'my-profile');

    const handleLogEvent = (eventName?: string) => {
        if (eventName) {
            trackPixelEvent(eventName, { anonymized_user_id: MyProfile?.[0]?._id, name: MyProfile?.[0]?.given_name, timestamp: new Date().toISOString(), role });
        }
    };

    const { currentLanguage } = useLanguage();

    const menuData = [
        {
            title: t('dashboard'),
            routing: `/${currentLanguage}/client/dashboard`,
            onClick: () => handleLogEvent("view_dashboard")
        },
        {
            title: t('cnt.main-menu'),
            sub: [
                {
                    title: t('cnt.consent-form'),
                    routing: `/${currentLanguage}/client/consent-form-doc`
                },
                {
                    title: t('cnt.health-assessment'),
                    routing: `/${currentLanguage}/client/health-assessment-doc`
                },
                {
                    title: t('cnt.my-booking'),
                    routing: `/${currentLanguage}/client/my-booking`,
                    onClick: () => handleLogEvent("view_my_bookings")
                },
                {
                    title: t('cnt.favorite'),
                    routing: `/${currentLanguage}/client/favorite`
                },
                {
                    title: t('add-complaint'),
                    routing: `/${currentLanguage}/client/add-complaint`,
                },
                {
                    title: t('cnt.view-complaint-by-me'),
                    routing: `/${currentLanguage}/client/view-complaint-by-me`,
                    onClick: () => handleLogEvent("view_complaint_by_me")
                },
                {
                    title: t('cnt.view-complaint-against-me'),
                    routing: `/${currentLanguage}/client/view-complaint-against`,
                    onClick: () => handleLogEvent("view_complaint_against_me")
                },
                {
                    title: t('cnt.general-infomation'),
                    routing: `/${currentLanguage}/client/general-info`
                }
            ]
        }
    ];

    const handleCloseMenu = () => dispatch(toggleSidebar());

    const nav = <Navbar orientation='horizontal' color={settings.topbarColor} background={settings.topbarBg} boxed={settings.boxed}>
        <button className='no-style navbar-toggle d-lg-none' onClick={handleCloseMenu}>
            <span /><span /><span />
        </button>

        <WebLogo showLang={false} />
        <Actions />
    </Navbar>

    const additionalNav = (
        <Navbar minHeight={40} boxed={settings.boxed} color={settings.sidebarColor} background={settings.sidebarBg} opened={settings.sidebarOpened} onClickOutside={handleCloseMenu} orientation='horizontal-vertical'>
            <div className='navbar-mobile-header'>
                <WebLogo showLang={false} />
                <button onClick={handleCloseMenu} className='no-style navbar-close icofont-close-line d-lg-none ml-2' />
            </div>
            <MyMenu onCloseSidebar={handleCloseMenu} opened={settings.sidebarOpened} orientation='horizontal' routingview='client' data={menuData} />
        </Navbar>
    );

    return <BaseLayout orientation='horizontal' nav={nav} topNav={additionalNav}>{children} </BaseLayout>
};

export default ClientLayout;
